import { render, staticRenderFns } from "./EmptyFolders.vue?vue&type=template&id=337770b6&scoped=true&"
import script from "./EmptyFolders.vue?vue&type=script&lang=js&"
export * from "./EmptyFolders.vue?vue&type=script&lang=js&"
import style0 from "./EmptyFolders.vue?vue&type=style&index=0&id=337770b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337770b6",
  null
  
)

export default component.exports